<template>
  <div class="mt-2 dir-container" role="tree" aria-label="Scenario folders">
    <div v-if="isLoading" class="tree-status">Loading folders…</div>
    <template v-else>
      <RecursiveDirectoryTree
        v-for="dir in directoryTree"
        :key="dir.uuid"
        :directory="dir"
      />
    </template>
    <!-- Clicks are stopped so they don't trigger the surrounding "My scenarios" router-link -->
    <button
      type="button"
      class="new-folder-button"
      @click.stop.prevent="onCreate"
    >
      <span class="material-icons">add</span>
      New folder
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecursiveDirectoryTree from "@/components/ScenarioDirectoryTree/RecursiveDirectoryTree";
import { createFolder } from "@/utils/folder.helper";

export default {
  name: "ScenarioDirectoryTreeContainer",
  components: { RecursiveDirectoryTree },
  props: ["isActive"],
  mounted() {
    this.$store.dispatch("scenarioDirectoriesStore/loadDirectoryTree");
  },
  computed: {
    ...mapGetters("scenarioDirectoriesStore", ["directoryTree", "isLoading"]),
  },
  methods: {
    onCreate() {
      createFolder(this);
    },
  },
};
</script>

<style scoped>
.dir-container {
  /* Line up with the "My scenarios" icon above, and use the full width */
  margin-left: -32px;
  margin-right: -8px;
}

.tree-status {
  padding: 6px 8px;
  font-size: 0.85rem;
  color: var(--isim-light-text);
}

.new-folder-button {
  display: flex;
  align-items: center;
  width: 100%;
  height: 32px;
  margin-top: 2px;
  padding: 0 4px 0 26px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--isim-light-text);
  font-size: 0.9rem;
  cursor: pointer;
}

.new-folder-button:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--isim-primary);
}

.new-folder-button .material-icons {
  font-size: 18px;
  margin: 0 8px 0 2px;
}
</style>
